export class SamwinDeviceAddressChangedByServer {
   public static readonly type = '[Samwin] Device Address Changed';

   constructor(public deviceAddress: string) {}
}

export class OpenUrlInNewWindow {
   public static readonly type = '[Samwin] Open URL In New Window';

   constructor(public urlWithWildCards: string) {}
}
